import usersMutations from "./mutations";
import usersActions from "./actions";

export default {
  namespaced: true,
  state: {
    users: [],
    user: null
  },
  getters: {
    getUsers: (state) => state.users,
    getUser: (state) => state.user,
  },
  mutations: usersMutations,
  actions: usersActions,
};
